// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button_cancel-editor {\n  padding: 0.5rem 2.2rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: var(--font-title);\n  border-radius: 8px;\n  text-transform: uppercase; }\n  .button_cancel-editor.btn {\n    background-color: var(--gray-800);\n    color: white; }\n", ""]);
// Exports
module.exports = exports;
